import { Badge, Button, Drawer, IconButton, List, ListItemButton, ListItemIcon} from '@mui/material'
import React, { useEffect, useState } from 'react'
import MenuIcon from '@mui/icons-material/Menu';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { getTotals } from '../../features/slices/cartSlice';
import PersonIcon from '@mui/icons-material/Person';
import FilterFramesIcon from '@mui/icons-material/FilterFrames';
import FavoriteIcon from '@mui/icons-material/Favorite';

const DrawerMobile = ({handleLogout}) => {

  const [openDrawer, setOpenDrawer] = useState(false)
  const user = JSON.parse(localStorage.getItem('user'))

  const logoutMobile = () => handleLogout()
  const navigate = useNavigate()
  const [pQ, setPq] = useState(0);
  const [finished, setFinished] = useState(false);


  const dispatch = useDispatch()
  const cart = useSelector(state => state.cart)
  useEffect(() => {
    dispatch(getTotals())
  }, [cart, dispatch])

  const favorite = useSelector(state => state.favorite)
  useEffect(() => {
    dispatch(getTotals())
  }, [favorite, dispatch])
  
//   const currentProducts = JSON.parse(localStorage.getItem("cartItems"))
//   let quantity = 0
//   useState(() => {
//     console.log("CALLED######################")
//     currentProducts.map(currentProduct => {
//         console.log("pq is", pQ)
//         quantity += currentProduct.cartQuantity
//     })
//     setPq(quantity)
//     setFinished(true)
//   }, [currentProducts])

  return (
    <div style={{marginLeft: 'auto'}}>
        <Drawer   
        PaperProps={{
            sx: {
            width: 300,
            }
        }} 
        open={openDrawer} 
        onClose={() => setOpenDrawer(false)}>
        <List style={{display: 'flex', flexDirection: 'column'}}>
            <ListItemButton onClick={() => setOpenDrawer(!openDrawer)}>
                <ListItemIcon>
                    <Link style={{textDecoration: 'none'}} to="/smartphones/1">Smartphones</Link>
                </ListItemIcon>
            </ListItemButton>
            <ListItemButton onClick={() => setOpenDrawer(!openDrawer)}>
                <ListItemIcon>
                    <Link style={{textDecoration: 'none'}} to="/headphones/1">Headphones</Link>
                </ListItemIcon>
            </ListItemButton>
            <ListItemButton onClick={() => setOpenDrawer(!openDrawer)}>
                <ListItemIcon>
                    <Link style={{textDecoration: 'none'}} to="/chargers/1">Chargers</Link>
                </ListItemIcon>
            </ListItemButton>
            <ListItemButton onClick={() => setOpenDrawer(!openDrawer)}>
                <ListItemIcon>
                    <Link style={{textDecoration: 'none'}} to="/phonecases/1">Phonecases</Link>
                </ListItemIcon>
            </ListItemButton>

            {user?.isAdmin && 
            <ListItemButton onClick={() => setOpenDrawer(!openDrawer)}>
                <ListItemIcon>
                    <li><Link style={{textDecoration: 'none'}} to="/users">Users</Link></li>
                </ListItemIcon>
            </ListItemButton> 
          }

            <ListItemButton onClick={() => setOpenDrawer(!openDrawer)}>
                <ListItemIcon>
                {user && (
                      <li>
                      <Button variant="contained" color="secondary" onClick={logoutMobile}>
                        <Link style={{textDecoration: 'none', color: '#000'}} to="/logout">Logout</Link>
                      </Button>
                    </li>
                )}
                </ListItemIcon>
            </ListItemButton>


            <ListItemButton onClick={() => setOpenDrawer(!openDrawer)}>
                <ListItemIcon>
                {!user &&
                  (<div style={{display: 'flex', flexDirection: 'column'}}>
                    <li>
                      <Button variant="contained" style={{marginBottom: '20px'}}>
                          <Link style={{textDecoration: 'none', color: '#fff', fontWeight: 'bold'}} to="/login">Login</Link>
                        </Button>
                    </li>
                    <li>
                      <Button variant="contained">
                          <Link style={{textDecoration: 'none', color: '#fff', fontWeight: 'bold'}} to="/register">Register</Link>
                        </Button>
                    </li>
                  </div>)
                }
                </ListItemIcon>
            </ListItemButton>
        </List>
        </Drawer>
        <div style={{width: '250px', display: 'flex', justifyContent: 'space-between'}}>
            <div>
            <IconButton sx={{color: "#fff", display: 'flex', justifyContent: 'flex-end'}} onClick={() => navigate(`/favorite/find/${user?._id}`)}>
                <Badge badgeContent={favorite.favoriteTotalQuantity} color="secondary">
                    <FavoriteIcon></FavoriteIcon>
                </Badge>
            </IconButton>
            </div>
            <div>
            <IconButton sx={{color: "#fff", display: 'flex', justifyContent: 'flex-end'}} onClick={() => navigate(`/cart/find/${user?._id}`)}>
                <Badge badgeContent={cart.cartTotalQuantity} color="secondary">
                    <AddShoppingCartIcon></AddShoppingCartIcon>
                </Badge>
            </IconButton>
            </div>

        
            {user?.isAdmin &&
            <div>
            <IconButton sx={{color: "#fff", display: 'flex', justifyContent: 'flex-end'}} onClick={() => navigate(`/orders`)}>
                    <FilterFramesIcon></FilterFramesIcon>
            </IconButton>
            </div>}
            <div>
            <IconButton sx={{color: "#fff", display: 'flex', justifyContent: 'flex-end'}} onClick={() => navigate(`/account/${user?._id}`)}>
                <Badge color="primary">
                    <PersonIcon></PersonIcon>
                </Badge>
            </IconButton>
            </div>
            <div>
            <IconButton sx={{color: "#fff", display: 'flex'}} onClick={() => setOpenDrawer(!openDrawer)}>
                <MenuIcon></MenuIcon>
            </IconButton>
            </div>
        </div>
    </div>
  )
}

export default DrawerMobile